import React from "react";
import { Link } from "react-router-dom";
import tool1 from "../../Assets/tool1.webp";
import tool2 from "../../Assets/tool2.webp";
import tool3 from "../../Assets/tool3.webp";
import tool4 from "../../Assets/tool4.webp";
import tool5 from "../../Assets/tool5.webp";
import "./YogaVariations.css";

// `to` is the page the button under the chart opens (/tool/<page name>)
const TOOLS = [
  {
    src: tool1,
    alt: "How to use a chair in 17 yoga poses",
    to: "/tool/yoga-with-the-chair",
    cta: "Yoga with the Chair",
  },
  {
    src: tool2,
    alt: "How to use yoga bricks (blocks) in 15 poses",
    to: "/tool/yoga-with-the-bricks",
    cta: "Yoga with the Bricks",
  },
  {
    src: tool3,
    alt: "How to use a wall in 17 yoga poses",
    to: "/tool/yoga-with-the-wall",
    cta: "Yoga with the Wall",
  },
  {
    src: tool4,
    alt: "How to use a yoga belt (or strap) in 16 poses",
    to: "/tool/yoga-with-the-belt",
    cta: "Yoga with the Belt",
  },
  {
    src: tool5,
    alt: "How to use a yoga wheel in 15 poses",
    to: "/tool/yoga-with-the-wheel",
    cta: "Yoga with the Wheel",
  },
];

const YogaTools = () => (
  <section
    className="yoga-variations yoga-tools"
    aria-labelledby="yoga-tools-title"
  >
    <h2 id="yoga-tools-title">How to use Yoga Tools</h2>

    <div className="yoga-variations-grid">
      {TOOLS.map((t) => (
        <figure className="yoga-variation-card" key={t.alt}>
          <img src={t.src} alt={t.alt} loading="lazy" />
          <Link className="yoga-variation-link" to={t.to}>
            {t.cta}
          </Link>
        </figure>
      ))}
    </div>
  </section>
);

export default YogaTools;
